import React from 'react';
import { fmtBytes } from './utils';

function VMAgentInfoPanel({ agentInfo, agentNetworks }) {
  return (
    <div className="agent-info-row">
      {/* Partições com gráfico pizza */}
      {agentInfo?.filesystems?.length > 0 && (
        <div className="agent-fs-panel">
          <div className="agent-fs-title">💾 Partições</div>
          <div className="agent-fs-list">
            {agentInfo.filesystems.map((fs, i) => {
              const free = fs.total - fs.used;
              const pct = fs.percent;
              const color = pct >= 90 ? '#ef4444' : pct >= 75 ? '#f59e0b' : '#3b82f6';
              const cx = 40, cy = 40, r = 36;
              const angle = (pct / 100) * 360;
              const rad = (a) => (a - 90) * Math.PI / 180;
              const x1 = cx + r * Math.cos(rad(0));
              const y1 = cy + r * Math.sin(rad(0));
              const x2 = cx + r * Math.cos(rad(angle));
              const y2 = cy + r * Math.sin(rad(angle));
              const largeArc = angle > 180 ? 1 : 0;
              const piePath = pct >= 100
                ? `M ${cx},${cy} m -${r},0 a ${r},${r} 0 1,1 ${r*2},0 a ${r},${r} 0 1,1 -${r*2},0 Z`
                : `M ${cx},${cy} L ${x1},${y1} A ${r},${r} 0 ${largeArc},1 ${x2},${y2} Z`;
              return (
                <div key={i} className="agent-fs-card">
                  <div className="agent-fs-pie-wrap">
                    <svg className="agent-fs-pie" viewBox="0 0 80 80">
                      <circle cx={cx} cy={cy} r={r} fill="var(--bg-input)" stroke="var(--border)" strokeWidth="1" />
                      {pct > 0 && <path d={piePath} fill={color} opacity="0.85" />}
                      <circle cx={cx} cy={cy} r={r} fill="none" stroke="var(--border)" strokeWidth="1" />
                    </svg>
                    <span className="agent-fs-pie-label" style={{ color }}>{pct}%</span>
                  </div>
                  <div className="agent-fs-info">
                    <span className="agent-fs-mount">{fs.mountpoint}</span>
                    <span className="agent-fs-type">{fs.type}</span>
                    <span className="agent-fs-size">{fmtBytes(fs.used)} / {fmtBytes(fs.total)}</span>
                    <span className="agent-fs-free">{fmtBytes(free)} livre</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Interfaces de Rede */}
      {agentNetworks?.agentRunning && agentNetworks.interfaces.length > 0 && (
        <div className="agent-net-panel">
          <div className="agent-net-title">🖧 Interfaces de Rede</div>
          <div className="agent-net-list">
            {agentNetworks.interfaces.map((iface, i) => (
              <div key={i} className="agent-net-iface">
                <div className="agent-net-iface-name">
                  <span className="agent-net-name">{iface.name}</span>
                  {iface.mac && <><span className="agent-net-sep"> - </span><span className="agent-net-mac"><span className="agent-net-mac-label">MAC:</span> {iface.mac}</span></>}
                </div>
                <div className="agent-net-addrs">
                  {iface.addresses.length === 0 && (
                    <span className="agent-net-noip">sem endereço</span>
                  )}
                  {(() => {
                    const v4 = iface.addresses.find(a => a.type === 'ipv4');
                    const v6 = iface.addresses.find(a => a.type === 'ipv6');
                    return (
                      <span className="agent-net-ip-line">
                        {v4 && <span className="agent-net-ip agent-net-ip-ipv4"><span className="agent-net-ip-label">IPv4:</span> {v4.ip}/{v4.prefix}</span>}
                        {v6 && <span className="agent-net-ip agent-net-ip-ipv6"><span className="agent-net-ip-label">IPv6:</span> {v6.ip}/{v6.prefix}</span>}
                      </span>
                    );
                  })()}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default VMAgentInfoPanel;
